import gql from 'graphql-tag';

// Note that this query is for the Confluence GraphQL instance
export const TrialDetailsQuery = (experimentName: string) => {
	const query = `query ${experimentName}_TrialDetailsQuery {
		license {
			trialEndDate
			billingSourceSystem
		}
	}`;

	return gql([query]);
};
